import { render } from "./SumatraBenzoin.vue?vue&type=template&id=73869cd0"
import script from "./SumatraBenzoin.vue?vue&type=script&lang=js"
export * from "./SumatraBenzoin.vue?vue&type=script&lang=js"

import "@/assets/css/source-detail.css?vue&type=style&index=0&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__